import { Controller } from "@hotwired/stimulus";

// Enhances a <details> disclosure menu: closes on Escape (returning focus to
// the summary) and on clicks or focus moving outside it.
export default class extends Controller {
  static targets = ["summary"];

  connect() {
    this.boundOutsideClick = this.closeOnOutsideInteraction.bind(this);
    document.addEventListener("click", this.boundOutsideClick);
    document.addEventListener("focusin", this.boundOutsideClick);
  }

  disconnect() {
    document.removeEventListener("click", this.boundOutsideClick);
    document.removeEventListener("focusin", this.boundOutsideClick);
  }

  closeOnEscape(event) {
    if (event.key !== "Escape" || !this.element.open) return;

    event.preventDefault();
    this.element.open = false;
    this.summaryTarget.focus();
  }

  closeOnOutsideInteraction(event) {
    if (this.element.open && !this.element.contains(event.target)) {
      this.element.open = false;
    }
  }
}
